import { Center, Text } from "@mantine/core";
import classes from "./Contact.module.css";
import { useMediaQuery } from "@mantine/hooks";
import { FaLinkedin } from "react-icons/fa";
import { IoMdMail, IoMdText } from "react-icons/io";

const linkedInURI = "https://www.linkedin.com/in/andrew-tanaka-5a241b1a7/";
const mailtoURI =
  "mailto:andrewleift@gmail.com?subject=*CONTACT%20ME*%20<Your%20Subject>&body=Hello%20Andrew%20Tanaka,%20";
const smsURI = "sms:+1-919-599-3116?body=Hello%20Andrew%20Tanaka,%20";

const Contact = () => {
  const mobile = useMediaQuery("(max-width: 46em)");

  return (
    <div className={classes["contact-wrapper"]}>
      <Center style={{ flexDirection: "column" }}>
        <div className={classes["title-wrapper"]}>
          <Text>
            Thanks for stopping by! If you have any questions or would like to
            get in touch, feel free to reach out via
            {mobile ? " email, linkedin, or by text " : " email or linkedin "}
            using the links below.
          </Text>
        </div>
        <div className={classes["banner-icon-container"]}>
          {mobile && (
            <a href={smsURI} className={classes["link-wrapper"]}>
              <div className={classes["link-text"]}>{"Shoot Me a Text"}</div>
              <IoMdText className={classes["banner-icon"]} />
            </a>
          )}

          <a href={mailtoURI} className={classes["link-wrapper"]}>
            <div className={classes["link-text"]}>{"Send Me an Email"}</div>
            <IoMdMail className={classes["banner-icon"]} />
          </a>

          <a
            href={linkedInURI}
            target="_blank"
            rel="noopener"
            className={classes["link-wrapper"]}
          >
            <div className={classes["link-text"]}>{"Let's Link"}</div>
            <FaLinkedin className={classes["banner-icon"]} />
          </a>
        </div>
      </Center>
    </div>
  );
};

export default Contact;
